import * as React from 'react';
import type { SVGProps } from 'react';

const SvgPaywallFeatureCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="#00CE8F"
      fillRule="evenodd"
      d="M10 1.667a8.333 8.333 0 1 0 0 16.666 8.333 8.333 0 0 0 0-16.666m3.145 6.777a.833.833 0 0 0-1.29-1.055l-3.167 3.871-1.015-1.016a.833.833 0 0 0-1.179 1.179l1.667 1.666a.833.833 0 0 0 1.234-.062z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgPaywallFeatureCheck;
